import NewsCard from "./news-card";

export { NewsCard };
